import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { EmptyState, SkeletonRows } from '@/components/ui';
import { useHierarchyIndex } from '@/features/hierarchy/api';
import { LocationIcon } from '@/features/hierarchy/location-icon';
import { Page } from '@/features/shell/page';
import type { TaskScope } from '@/features/tasks/api';
import { TaskViewPage } from '@/features/tasks/task-view-page';

export const Route = createFileRoute('/w/$workspaceId/l/$listId')({ component: ListPage });

function ListPage() {
  const { listId } = Route.useParams();
  const index = useHierarchyIndex();
  const list = index.list(listId);
  const scope = useMemo<TaskScope>(() => ({ type: 'list', id: listId }), [listId]);

  if (index.isLoading) {
    return (
      <Page title="List">
        <SkeletonRows className="p-6" />
      </Page>
    );
  }
  if (!list) {
    return (
      <Page title="List">
        <EmptyState
          className="h-full"
          title="List not found"
          description="It may have been deleted, or you do not have access."
        />
      </Page>
    );
  }
  return (
    <TaskViewPage
      scope={scope}
      title={index.listPath(listId)}
      icon={<LocationIcon kind="list" icon={list.icon} color={list.color} />}
    />
  );
}
